// 将十六进制转换为RGB 数组
// const hexToRgb = (hex: string): [number, number, number] | null =>
//   /^#?([a-fA-F0-9]{6})$/.test(hex)
//     ? ([0, 2, 4].map((offset) => parseInt(hex.slice(offset + 1, offset + 3), 16)) as [number, number, number])
//     : null;
// 将十六进制转换为RGB 字符串 XXX,XXX,XXX
const hexToRgbJoin = (hex: string): string =>
  /^#?([a-fA-F0-9]{6})$/.test(hex)
    ? [0, 2, 4].map((offset) => parseInt(hex.slice(offset + 1, offset + 3), 16)).join(",")
    : null;

export default hexToRgbJoin;
